<template>
    <v-dialog v-model="$store.state.Suncor.Ucd" height="800px" fullscreen>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    Statement Uploaded By Clearing Doc
                    </v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.Suncor.Ucd = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container>
                <v-data-table
                    :headers="headersSummary"
                    :items="Clear"
                    :search="search"
                    dense
                    height="600px"
                    disable-items-per-page
                    disable-pagination 
                    class="custom-table" 
                    hide-default-footer 
                    :fixed-header="true" 
                >
                <template v-slot:top>  
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                label="Search"
                                v-model="search"
                                class="mb-5"
                                dense
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            
                    <v-btn
                        color="success"
                        small
                        class="float-right mt-3"
                        @click="downloadExcel"
                    >
                        Download
                        <v-icon class="ml-2">mdi-microsoft-excel</v-icon>
                    </v-btn>
                        </v-col>
                    </v-row>
                </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['parms'],
    data: function() {
        return {
            headersSummary:[
                {text:'File Name',value:'fileName'},
                {text:'PaymentDocument',value:'PaymentDocument'},
                {text:'Clearing',value:'Clearing'},
                {text:'Registration Date',value:'regPmtDttm'},
                
                
                {text:'Subtotal',value:'Subtotal'},
                {text:'SurchargeAmt',value:'SurchargeAmt'},
                {text:'Taxes',value:'Taxes'},
                {text:'TotalPmt',value:'TotalPmt'},
            ],
            Clear:[],
            Totals:{
                TotalNetAmount : null,
                TotalInvoiceNumber : null,
                TotalDiff : null,
            },
            search:''
        };
    },
    
    mounted(){
        console.log(this.parms);
        this.getMatchs();
    },
    methods: {
        getMatchs: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('conciliation/suncor/uploaded-clearing',this.parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.Clear = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:'You do not have the permission to use this function.'
                        });
                    };
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:'This file is already uploaded.'
                        });
                                
                    }
                    str.state.isLoading = false;
                });
        },
        downloadExcel: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.parms.Export = 1;
            axios
                .post('conciliation/suncor/uploaded-clearing',this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute(
                        'download',
                        'Statement Summary Report By Range.xlsx'
                    );

                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
<style>
.custom-table .v-data-table-header>th {
    background-color: #336ca5;
    /* Cambia este color al que desees */
    color: white;
    /* Cambia este color al que desees */
}
</style>